module.exports = __webpack_public_path__ + "aa41349320c476946b720082e5cc354e.jpg";